import React from "react";
import { ToolTip } from "@components/atoms/tooltip/tooltip";
import { useI18N } from "@src/language/language-context";
import { InfoIconButton } from "@src/components/atoms/info-icon-button/info-icon-button";

export interface InfoIconButtonPropTypes {
  isInfoIconActive: boolean;
  handleClick: () => void;
}

export const InfoIconButtonWrapperWithTooltip = ({
  isInfoIconActive,
  handleClick,
}: InfoIconButtonPropTypes) => {
  const i18n = useI18N();
  const texts = {
    infoText: i18n("modules.infoButton.infoText"),
  };
  return (
    <>
      {!isInfoIconActive ? (
        <ToolTip position={"bottom"} content={texts.infoText}>
          <InfoIconButton
            isIconActive={isInfoIconActive}
            handleClick={handleClick}
            iconName={"info_icon"}
          />
        </ToolTip>
      ) : (
        <InfoIconButton
          iconName={"info_icon"}
          isIconActive={isInfoIconActive}
          handleClick={handleClick}
        />
      )}
    </>
  );
};
